/**
 * @fileoverview POST handler for the "/engagement/segment_preview/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentPreviewResult } from "./constants";
import type { EngagementSegmentPreviewResult, PostEngagementSegmentPreviewProps } from "./types";

export const getEngagementSegmentPreview = reactQueryFetcherAdapter(
  engagementSegmentPreviewResult,
  (signal: AbortSignal, props: PostEngagementSegmentPreviewProps): Promise<EngagementSegmentPreviewResult> => {
    return fetch(
      `/engagement/segment_preview/${props.appGroupId}`,
      "POST",
      {
        override_filter_values: {},
        reachable_channels: [],
        segment_id: props.segmentId,
        subscription_group_id: null,
        subscriptions: null,
      },
      { signal }
    );
  }
);
